import { Breadcrumb } from "@gull";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";

import "react-datepicker/dist/react-datepicker.css";
import { Formik } from "formik";
import * as Yup from "yup";

import { addReqToAdmin } from "app/services/paymentService";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";

import { getBankList } from "app/services/AdminServices/bankService";
import AllMemberAutoComplete from "../Credit Settings/AllMemberAutoComplete";
import enableCreditReq from "config.json";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import usePagePermission from "app/hooks/usePagePermission";

const requisitionSchema = Yup.object().shape({
  amount: Yup.number()
    .required("Please enter Amount")
    .min(1, "Amount should be greater than 0"),
  bankId: Yup.string().when("pgType", {
    is: "NORMAL",
    then: Yup.string().required("Please select bank"),
  }),
  transferMethod: Yup.string().when("pgType", {
    is: "NORMAL",
    then: Yup.string().required("Please select Payment Type"),
  }),
  referenceNo: Yup.string()
    .when("pgType", {
      is: "NORMAL",
      then: Yup.string().required("Please select Reference Number"),
    })
    .min(6, "Reference must be at least 6 characters"),
  requestDate: Yup.string().when("pgType", {
    is: "NORMAL",
    then: Yup.string().required("Please select Request Date"),
  }),
  memId: Yup.string().required("Please select Introducer Dist"),
  transactionDetails: Yup.string().optional(),
  remarks: Yup.string().optional(),
});

function AddReq() {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  const navigate = useNavigate();

  const item = {
    requestDate: "",
    amount: "",
    bankId: "",
    transactionDetails: "",
    transferMethod: "NEFT",
    memId: "",
    bankCharges: 0,
    referenceNo: "",
    bankList: [],
    pgType: "NORMAL",
    pgTypeOptions: [
      { value: "NORMAL", label: "Normal" },
      { value: "CREDIT", label: "Credit" },
    ],
    paymentTypeList: [
      { value: "CASH", label: "CASH" },
      { value: "NEFT", label: "NEFT" },
      { value: "UPI", label: "UPI" },
      { value: "RTGS", label: "RTGS" },
      { value: "ONLINE", label: "ONLINE" },
      { value: "CHEQUE", label: "CHEQUE" },
    ],
    transactionDetails: "",
    remarks: "",
  };
  const [initialState, SetInitialState] = useState(item);
  const [bankState, SetBankState] = useState([]);

  const loadBankLists = async () => {
    const response = await getBankList();
    const bankData = response.data;
    const bankList = bankData.map((x, i) => {
      return {
        value: x.id,
        label: x.bankName,
      };
    });

    SetBankState(bankList);
  };

  useEffect(() => {
    loadBankLists();
  }, []);

  const requisitionHandler = async (values, { resetForm }) => {
    if (values.bankId == "") {
      values.bankId = 0;
    }
    const res = await addReqToAdmin(values);

    if (res.status == "Success") {
      navigate("/admin/payments/all-req");
      NotificationManager.success("Requisition done successfully");
    } else {
      NotificationManager.danger("Requisition Failed");
    }

    document
      .querySelectorAll("input[type=checkbox]")
      .forEach((el) => (el.checked = false));
    resetForm({ values: "" });
  };

  // const handlChangeDate = (date) => {
  //   this.setState({
  //     requestDate: moment(date).format("DD-MM-YYYY"),
  //   });
  // };

  return (
    <div>
      <Helmet>
        <title>Add Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Add Requisition" }]}></Breadcrumb>
      <div>
        <Card>
          <Card.Body>
            <Formik
              initialValues={initialState}
              validationSchema={requisitionSchema}
              onSubmit={requisitionHandler}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  {/* <div>
                    <div className="col-md-12">
                      {Object.values(errors).map((msg) => (
                        <>
                          {msg}
                          <br />
                        </>
                      ))}
                    </div>
                  </div> */}
                  <div className="px-3">
                    <Row>
                      {enableCreditReq ? (
                        <RenderSelectInput
                          name="pgType"
                          display="Requisition Type"
                          placeholder="Requisition Type"
                          value={values.pgType}
                          error={errors.pgType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.pgType}
                          items={item.pgTypeOptions}
                          required
                        ></RenderSelectInput>
                      ) : (
                        ""
                      )}
                    </Row>

                    {values.pgType === "CREDIT" ? (
                      <Row>
                        <Col xs={12} md={4}>
                          <div className="w-100">
                            <label> Member List </label>
                            <span className="text-danger"> * </span>
                            <AllMemberAutoComplete
                              setFieldValue={setFieldValue}
                              memId={item.memId}
                              handleChangeOptions={(memId) => {
                                setFieldValue("memId", memId);
                                // this.setState({ memId });
                              }}
                              name="memId"
                              value={values.memId}
                              // required
                            />
                            {!values.memId ? (
                              <small className="text-danger">
                                {errors.memId}
                              </small>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col xs={12} md={4}>
                          <RenderTextInput
                            type="text"
                            name="amount"
                            display="Amount"
                            placeholder="Amount"
                            value={values.amount}
                            error={errors.amount}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.amount}
                            required
                          ></RenderTextInput>
                        </Col>
                        <Col xs={12} md={4}>
                          <RenderTextInput
                            type="text"
                            name="transactionDetails"
                            display="Remarks (if any)"
                            placeholder="transactionDetails"
                            value={values.transactionDetails}
                            error={errors.transactionDetails}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.transactionDetails}
                            // required
                          ></RenderTextInput>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row>
                          <Col xs={12} md={4}>
                            <div className="w-100">
                              <label> Member List </label>
                              <span className="text-danger"> * </span>
                              <AllMemberAutoComplete
                                setFieldValue={setFieldValue}
                                memId={item.memId}
                                handleChangeOptions={(memId) => {
                                  setFieldValue("memId", memId);
                                  // this.setState({ memId });
                                }}
                                name="memId"
                                value={values.memId}
                                // required
                              />
                              {!values.memId ? (
                                <small className="text-danger">
                                  {errors.memId}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>

                          <Col xs={12} md={4}>
                            <RenderSelectInput
                              name="bankId"
                              display="Bank List"
                              placeholder="Bank List"
                              value={values.bankId}
                              error={errors.bankId}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.bankId}
                              items={bankState}
                              required
                            ></RenderSelectInput>
                          </Col>
                          <Col xs={12} md={4}>
                            <RenderSelectInput
                              name="transferMethod"
                              display="Payment Type"
                              placeholder="Payment Through"
                              value={values.transferMethod}
                              error={errors.transferMethod}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.transferMethod}
                              items={item.paymentTypeList}
                              required
                            ></RenderSelectInput>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} md={4}>
                            <RenderTextInput
                              type="text"
                              name="amount"
                              display="Amount"
                              placeholder="Amount"
                              value={values.amount}
                              error={errors.amount}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.amount}
                              required
                            ></RenderTextInput>
                          </Col>
                          <Col xs={12} md={4}>
                            <RenderTextInput
                              type="text"
                              name="referenceNo"
                              display="Reference No"
                              placeholder="Reference No"
                              value={values.referenceNo}
                              error={errors.referenceNo}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.referenceNo}
                              required
                            ></RenderTextInput>
                          </Col>

                          <Col xs={12} md={4}>
                            <RenderDateInput
                              type="date"
                              name="requestDate"
                              display="Request Date"
                              onBlur={handleBlur}
                              value={values.requestDate}
                              onChange={handleChange}
                              touched={touched.requestDate}
                              error={errors.requestDate}
                              required
                              max={moment(new Date()).format("yyyy-MM-DD")}
                            ></RenderDateInput>
                          </Col>
                          <Col xs={12} md={4} lg={6}>
                            <RenderTextArea
                              name="transactionDetails"
                              display="Transaction Details"
                              placeholder="Transaction Details"
                              value={values.transactionDetails}
                              error={errors.transactionDetails}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched.transactionDetails}
                            ></RenderTextArea>
                          </Col>
                          <Col xs={12} md={4} lg={6}>
                            <RenderTextArea
                              name="remarks"
                              display="Remarks"
                              placeholder="Remarks"
                              onBlur={handleBlur}
                              value={values.remarks}
                              onChange={handleChange}
                              touched={touched.remarks}
                              error={errors.remarks}
                            ></RenderTextArea>
                          </Col>
                        </Row>
                      </>
                    )}
                    {canAdd && (
                      <Row>
                        <Col className="mt-2">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isSubmitting}
                          >
                            {isSubmitting
                              ? "Submitting..."
                              : "Submit Requisition"}
                          </button>
                        </Col>
                      </Row>
                    )}
                  </div>
                </form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default AddReq;
